import React, { Fragment, useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
} from 'reactstrap';
import classnames from 'classnames';
import DevpegawaiComponent from './Components/DevpegawaiComponent';
import PresensiComponent from './Components/PresensiComponent';
import PunishmentComponent from './Components/PunishmentComponent';
import ErrorAccess from '../../../components/Error/Content/Access';

const DashboardView = () => {
  const [activeTab1, setactiveTab1] = useState('5');

  function toggle1(tab) {
    if (activeTab1 !== tab) {
      setactiveTab1(tab);
    }
  }

  const [isHaveRoleDashboard, setIsHaveRoleDashboard] = useState(0);

  //PENGECEKAN ROLE
  const checkAccessRole = () => {
    let allRole = JSON.parse(sessionStorage.getItem('allRole'));
    allRole.forEach((item) => {
      if (item.access_id === 4 || item.access_name.includes('Inspektorat')) {
        setIsHaveRoleDashboard(1);
      }
    });
  };

  useEffect(() => {
    checkAccessRole();
  }, []);

  return (
    <Fragment>
      <Container fluid>
        <Row>
          <Col md={12}>
            {isHaveRoleDashboard === 0 ? (
              <ErrorAccess />
            ) : (
              <>
                <div
                  className="bg-white mt-2"
                  style={{
                    width: '100%',
                    padding: '5px 15px  5px 15px',
                    borderRadius: '20px',
                    boxShadow:
                      '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <Nav pills className="mt-3 mb-3">
                    <NavItem>
                      <NavLink
                        style={{ cursor: 'pointer' }}
                        className={classnames({
                          active: activeTab1 === '5',
                        })}
                        onClick={() => {
                          toggle1('5');
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="fas fa-home"></i>
                        </span>
                        <span className="d-none d-sm-block">Pegawai</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: 'pointer' }}
                        className={classnames({
                          active: activeTab1 === '6',
                        })}
                        onClick={() => {
                          toggle1('6');
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-user"></i>
                        </span>
                        <span className="d-none d-sm-block">Presensi</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: 'pointer' }}
                        className={classnames({
                          active: activeTab1 === '7',
                        })}
                        onClick={() => {
                          toggle1('7');
                        }}
                      >
                        <span className="d-block d-sm-none">
                          <i className="far fa-user"></i>
                        </span>
                        <span className="d-none d-sm-block">
                          Hukuman Disiplin
                        </span>
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>

                <div
                  className="content-subtitle bg-white"
                  style={{
                    marginTop: '15px',
                    padding: '15px',
                    width: '100%',
                    borderRadius: '20px',
                    boxShadow:
                      '-1px 1px 3px 1px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <h5 style={{ fontWeight: 'bold' }}>
                    Rekap Statistik Pegawai
                  </h5>
                </div>

                <TabContent activeTab={activeTab1} className="pt-3 text-muted">
                  <TabPane tabId="5">
                    <DevpegawaiComponent />
                  </TabPane>
                  <TabPane tabId="6">
                    <PresensiComponent />
                  </TabPane>
                  <TabPane tabId="7">
                    <PunishmentComponent />
                  </TabPane>
                </TabContent>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default DashboardView;
